


import React, { useRef, useState, useEffect } from "react";
import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import { useNavigate, useLocation } from "react-router-dom";
import ExpenseDetail from "./ExpenseDetail";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import { ApiUrl } from "../../../ApiUrl";
import { Button, Table, Form, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SelectSearchParty.css";

const AdmAttendanceEntry = () => {
  const [showModal, setShowModal] = useState(false);
  const [expenseNo, setExpenseNo] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dateRef = useRef(null);
  const [partyId, setPartyId] = useState("");
  const [partyName, setPartyName] = useState("");
  const [partyReference, setPartyReference] = useState("");
  const [balPay, setBalPay] = useState("");
  const [paidPay, setPaidPay] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [rows, setRows] = useState([
    { id: 1, category: "", amount: "", remarks: "" },
  ]);
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [loadingBanks, setLoadingBanks] = useState(true);
  const [loadingAccounts, setLoadingAccounts] = useState(false);
  const [errorBanks, setErrorBanks] = useState("");
  const [errorAccounts, setErrorAccounts] = useState("");
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [cashAmount, setCashAmount] = useState(0);
  const [bankAmount, setBankAmount] = useState();
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [expenseHeaderId, setExpenseHeaderId] = useState(null);
  // Fetch expense number from API
  useEffect(() => {
    const fetchExpenseNo = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}EXPENSE/EXPENSEHEADER/GetExpenseNo/`
        );
        const data = await response.json();
        if (data.message === "success") {
          setExpenseNo(data.expense_no);
        }
      } catch (error) {
        console.error("Error fetching expense number:", error);
      }
    };
    fetchExpenseNo();
  }, []);
  const handleSelectedParty = (selectedParty) => {
    console.log("Selected Party:", selectedParty);
    setPartyId(selectedParty.party_id || "");
    setPartyName(selectedParty.party_name || "");
    handleCloseModal();
  };

  const handleClear = () => {
    // if (dateRef.current) dateRef.current.value = "";
    setSelectedDate(new Date().toISOString().split("T")[0]);
    setPartyName("");
    setPartyReference("");
    setPaidPay("");
    setBalPay(0.0);
    setTotalAmount(0.0);
    setCashAmount(0.0);
    setBankAmount("");
    setSelectedBank("");
    setSelectedAccount("");
    setRows([{ id: 1, category: "", amount: "", remarks: "" }]);
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    // navigate("/admin/search-expense");
    setShowModal(false);
  };
  const handleCloseBut = () => {
    navigate("/admin/search-expense");
  };
  // Fetch Bank List on Component Mount
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}BANK/GetAllbankList/`);
        const result = await response.json();

        if (response.ok && result.data) {
          setBankList(result.data);
        } else {
          throw new Error("Failed to fetch bank list");
        }
      } catch (err) {
        setErrorBanks("Error fetching banks");
      } finally {
        setLoadingBanks(false);
      }
    };
    fetchBanks();
  }, []);
  // Fetch Account Details When a Bank is Selected
  const fetchAccountDetails = async (bankId) => {
    if (!bankId) return;
    setLoadingAccounts(true);
    setErrorAccounts(""); // Reset error message

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Account_Details/GetAccountDetailsBasedOnBankId/${bankId}`
      );
      const result = await response.json();

      if (response.ok) {
        if (result.message === "No record found!!") {
          setAccountList([]);
          setErrorAccounts("No accounts found for this bank.");
        } else if (result.data) {
          setAccountList(result.data);
        }
      } else {
        throw new Error("Failed to fetch account details.");
      }
    } catch (err) {
      setErrorAccounts("Error fetching account details");
      setAccountList([]);
    } finally {
      setLoadingAccounts(false);
    }
  };
  // Handle Bank Selection
  const handleBankChange = (event) => {
    const bankId = event.target.value;
    setSelectedBank(bankId);
    fetchAccountDetails(bankId);
  };
  // Fetch expense categories
  useEffect(() => {
    const fetchExpenseCategory = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}EXPENSE/EXPENSE_INCOME/ListBasedOnCategory/?org_id=${orgId}&branch_id=${branchId}&flag=E`
        );
        const data = await response.json();
        if (data.message === "success" && Array.isArray(data.data)) {
          setExpenseCategory(data.data);
        }
      } catch (error) {
        console.error("Error fetching expense categories:", error);
      }
    };
    fetchExpenseCategory();
  }, []);
  const handleAddRow = () => {
    const newRow = {
      id: rows.length + 1,
      category: "",
      amount: 0,
      remarks: "",
    };
    setRows([...rows, newRow]);
  };
  // Remove Row
  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };


  useEffect(() => {
    const cash = parseFloat(cashAmount) || 0;
    const bank = parseFloat(bankAmount) || 0;
    setPaidPay(cash + bank);
  }, [cashAmount, bankAmount]);

  // Calculate Balance Amount
  useEffect(() => {
    const balanceAmount = parseFloat(totalAmount) - parseFloat(paidPay);
    setBalPay(balanceAmount.toFixed(2));
  }, [totalAmount, paidPay]);
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    if (field === "amount") {
      const newTotalAmount = updatedRows.reduce(
        (acc, row) => acc + parseFloat(row.amount || 0),
        0
      );
      setTotalAmount(newTotalAmount);
      
    }

    setRows(updatedRows);
  };

  const handleCashChange = (e) => {
    const cashVal = e.target.value;

    // Allow clearing
    if (cashVal === "" || parseFloat(cashVal) === 0) {
      setCashAmount("");
      return;
    }

    const newCash = parseFloat(cashVal) || 0;
    const bank = parseFloat(bankAmount) || 0;
    const newPaid = newCash + bank;

    if (newPaid > totalAmount) {
      alert("The payment amount cannot be greater than total amount.");
      return;
    }

    setCashAmount(cashVal);
  };

  const handleBankAmountChange = (e) => {
    const bankVal = e.target.value;

    // Allow clearing
    if (bankVal === "" || parseFloat(bankVal) === 0) {
      setBankAmount("");
      return;
    }

    const cash = parseFloat(cashAmount) || 0;
    const newBank = parseFloat(bankVal) || 0;
    const newPaid = cash + newBank;

    if (newPaid > totalAmount) {
      alert("The payment amount cannot be greater than total amount.");
      return;
    }

    setBankAmount(bankVal);
  };

  const handleAccountChange = (event) => {
    setSelectedAccount(event.target.value);
  };

  // useEffect(() => {
  //   if (location.state?.expenseData) {
  //     const expenseData = location.state.expenseData;
  //     console.log("Received expenseData:", expenseData);
  //     setPartyId(expenseData.party_id || "");
  //     setPartyName(expenseData.party_name || "");
  //     setPartyReference(expenseData.party_reference || "");
  //     setExpenseNo(expenseData.expense_no || "");
  //     setBalPay(expenseData.balance_amount || "");
  //     setPaidPay(expenseData.paid_amount || "");
  //     setSelectedDate(
  //       expenseData.date || new Date().toISOString().split("T")[0]
  //     );
  //     setTotalAmount(expenseData.total_amount || 0);
  //     // Map rows
  //     if (Array.isArray(expenseData.ExpenseDetailsdata)) {
  //       setRows(
  //         expenseData.ExpenseDetailsdata.map((detail) => ({
  //           id: detail.expense_detail_id || Date.now(),
  //           category: detail.expense_categoryId || null,
  //           category_name: detail.expense_category_name || "",
  //           amount: detail.amount || "",
  //           remarks: detail.remarks || "",
  //         }))
  //       );
  //     } else {
  //       setRows([
  //         {
  //           id: Date.now(),
  //           category: null,
  //           category_name: "",
  //           amount: "",
  //           remarks: "",
  //         },
  //       ]);
  //     }
  //     // Payment details
  //     const cashPayment = expenseData.PaymentDetailsData?.find(
  //       (p) => p.payment_method === "Cash"
  //     );
  //     const bankPayment = expenseData.PaymentDetailsData?.find(
  //       (p) => p.payment_method === "Bank"
  //     );
  //     setCashAmount(cashPayment ? cashPayment.applied_amount : "");
  //     if (bankPayment) {
  //       (async () => {
  //         const bankId = bankPayment.bankId;
  //         setSelectedBank(bankId || "");
  //         setBankAmount(bankPayment.applied_amount || "");
  //         // Fetch account list first
  //         await fetchAccountDetails(bankId);
  //         // Then set selected account ID
  //         setSelectedAccount(bankPayment.bank_accountId || "");
  //       })();
  //     }
  //   }
  // }, [location.state]);

useEffect(() => {
  if (location.state?.expenseData) {
    const expenseData = location.state.expenseData;
    console.log("Received expenseData:", expenseData);

    setExpenseHeaderId(expenseData.expense_header_id || null); // <-- Store the header ID

    setPartyId(expenseData.party_id || "");
    setPartyName(expenseData.party_name || "");
    setPartyReference(expenseData.party_reference || "");
    setExpenseNo(expenseData.expense_no || "");
    setBalPay(expenseData.balance_amount || "");
    setPaidPay(expenseData.paid_amount || "");
    setSelectedDate(expenseData.date || new Date().toISOString().split("T")[0]);
    setTotalAmount(expenseData.total_amount || 0);

    // Map rows
    if (Array.isArray(expenseData.ExpenseDetailsdata)) {
      setRows(
        expenseData.ExpenseDetailsdata.map((detail) => ({
          id: detail.expense_detail_id || Date.now(),
          category: detail.expense_categoryId || null,
          category_name: detail.expense_category_name || "",
          amount: detail.amount || "",
          remarks: detail.remarks || "",
        }))
      );
    } else {
      setRows([
        {
          id: Date.now(),
          category: null,
          category_name: "",
          amount: "",
          remarks: "",
        },
      ]);
    }

    // Payment details
    const cashPayment = expenseData.PaymentDetailsData?.find(
      (p) => p.payment_method === "Cash"
    );
    const bankPayment = expenseData.PaymentDetailsData?.find(
      (p) => p.payment_method === "Bank"
    );
    setCashAmount(cashPayment ? cashPayment.applied_amount : "");
    if (bankPayment) {
      (async () => {
        const bankId = bankPayment.bankId;
        setSelectedBank(bankId || "");
        setBankAmount(bankPayment.applied_amount || "");
        await fetchAccountDetails(bankId);
        setSelectedAccount(bankPayment.bank_accountId || "");
      })();
    }
  }
}, [location.state]);


  // const handleSave = async () => {
  //   if (!partyId) {
  //     alert("Enter Party name");
  //     return;
  //   }
  //   if (!partyReference || partyReference.trim() === "") {
  //     alert("Enter Party Reference");
  //     return;
  //   }

  //   const filteredExpenseDetails = rows.filter(
  //     (row) => row.category && row.amount
  //   );
  //   if (filteredExpenseDetails.length === 0) {
  //     alert("Enter ExpenseDetails data");
  //     return;
  //   }

  //   const requestBody = {
  //     ExpenseHeaderadd: {
  //       created_by: sessionStorage.getItem("userId"),
  //       org_id: orgId,
  //       branch_id: branchId,
  //       partymasterId: partyId,
  //       date: selectedDate,
  //       expense_no: expenseNo,
  //       party_reference: partyReference,
  //       total_amount: parseFloat(totalAmount),
  //       paid_amount: parseFloat(paidPay),
  //       balance_amount: parseFloat(balPay),
  //     },
  //     ExpenseDetails: rows.map((row) => ({
  //       expensecategoryId: row.category,
  //       amount: parseFloat(row.amount),
  //       remarks: row.remarks || "xyz",
  //     })),
  //   };

  //   // Conditionally add cash or bank payment sections
  //   if (parseFloat(cashAmount) > 0) {
  //     requestBody.PaymentBasedOnCash = {
  //       payment_method: "Cash",
  //       cash_amount: parseFloat(cashAmount),
  //     };
  //   }

  //   if (parseFloat(bankAmount) > 0) {
  //     requestBody.PaymentBasedOnBank = {
  //       payment_method: "Bank",
  //       bank_amount: parseFloat(bankAmount),
  //       bankId: selectedBank,
  //       bank_accountId: selectedAccount,
  //     };
  //   }

  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}EXPENSE/EXPENSEHEADER/ExpenseCreate/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestBody),
  //       }
  //     );

  //     const result = await response.json();
  //     if (response.ok) {
  //       alert("Expense entry saved successfully!");
  //       handleClear();
  //     } else {
  //       alert(result.message || "Failed to save expense entry.");
  //     }
  //   } catch (error) {
  //     console.error("Error saving expense entry:", error);
  //     alert("An error occurred while saving expense entry.");
  //   }
  // };

const handleSave = async () => {
  if (!partyId) {
    alert("Enter Party name");
    return;
  }
  if (!partyReference || partyReference.trim() === "") {
    alert("Enter Party Reference");
    return;
  }

  const filteredExpenseDetails = rows.filter(
    (row) => row.category && row.amount
  );
  if (filteredExpenseDetails.length === 0) {
    alert("Enter ExpenseDetails data");
    return;
  }

  const requestBody = {
    ExpenseHeaderadd: {
      created_by: sessionStorage.getItem("userId"),
      org_id: orgId,
      branch_id: branchId,
      partymasterId: partyId,
      date: selectedDate,
      expense_no: expenseNo,
      party_reference: partyReference,
      total_amount: parseFloat(totalAmount),
      paid_amount: parseFloat(paidPay),
      balance_amount: parseFloat(balPay),
    },
    ExpenseDetails: rows.map((row) => ({
      expensecategoryId: row.category,
      amount: parseFloat(row.amount),
      remarks: row.remarks || "xyz",
    })),
  };

  if (parseFloat(cashAmount) > 0) {
    requestBody.PaymentBasedOnCash = {
      payment_method: "Cash",
      cash_amount: parseFloat(cashAmount),
    };
  }

  if (parseFloat(bankAmount) > 0) {
    requestBody.PaymentBasedOnBank = {
      payment_method: "Bank",
      bank_amount: parseFloat(bankAmount),
      bankId: selectedBank,
      bank_accountId: selectedAccount,
    };
  }

  try {
    const endpoint = expenseHeaderId
      ? `${ApiUrl.apiurl}EXPENSE/EXPENSEHEADER/ExpenseUpdate/${expenseHeaderId}`
      : `${ApiUrl.apiurl}EXPENSE/EXPENSEHEADER/ExpenseCreate/`;

    const method = expenseHeaderId ? "PUT" : "POST";

    const response = await fetch(endpoint, {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json();
    if (response.ok) {
      alert(
        expenseHeaderId
          ? "Expense entry updated successfully!"
          : "Expense entry saved successfully!"
      );
      handleClear();
    } else {
      alert(result.message || "Failed to save expense entry.");
    }
  } catch (error) {
    console.error("Error saving expense entry:", error);
    alert("An error occurred while saving expense entry.");
  }
};


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                EDIT EXPENSE
              </p>
              <div className="row mb-3 mt-3">
                <div className="col-12  d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleCloseBut}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row p-2 mt-3 position-relative">
                {/* Line with Hidden Section for Text */}
                <div className="position-relative w-100">
                  <div className="expense-header-line"></div>
                  {/* <h5 className="expense-header">Expense Header</h5> */}
                </div>

                <div
                  className="col-12 p-2"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    background: "white",
                  }}
                >
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="select-party" className="form-label">
                          Select Party<span style={{ color: "red" }}> *</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="select-party"
                            className="form-control detail"
                            value={partyName}
                            placeholder="Enter select-party"
                            disabled
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>
                      <SelectSearchParty
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelect={handleSelectedParty}
                      />
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="date" className="form-label">
                          Date <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          id="date"
                          className="form-control detail"
                          ref={dateRef}
                          max={new Date().toISOString().split("T")[0]}
                          value={selectedDate}
                          onChange={(e) => setSelectedDate(e.target.value)}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="expense-no" className="form-label">
                          Expense No.
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="expense-no"
                            className="form-control detail"
                            value={expenseNo}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="party-reference" className="form-label">
                          Party Reference{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="party-reference"
                            className="form-control detail"
                            value={partyReference}
                            onChange={(e) => setPartyReference(e.target.value)}
                            placeholder="Enter party reference"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="total-amount" className="form-label">
                          Total Amount
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="total-amount"
                            className="form-control detail"
                            placeholder="0.00"
                            value={totalAmount.toFixed(2)}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="paid-amount" className="form-label">
                          Paid Amount
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="paid-amount"
                            className="form-control detail"
                            value={paidPay}
                            placeholder="0.00"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="balance-amount" className="form-label">
                          Balance Amount
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="balance-amount"
                            className="form-control detail"
                            value={balPay}
                            placeholder="0.00"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row p-2">
                <div
                  className="col-12 mt-3"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  {/* <div className="mt-2">
                    <h5 style={{ color: "black" }}>Expense Detail</h5>
                    <Table bordered hover>
                      <thead className="thead-dark">
                        <tr>
                          <th>Sr.No</th>
                          <th>Expense Category</th>
                          <th>Amount</th>
                          <th>Remarks</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <Form.Control
                                as="select"
                                className="form-select"
                                value={row.category}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">Select</option>
                                {expenseCategory.map((category) => (
                                  <option
                                    key={category.expense_category_id}
                                    // value={category.expense_category}
                                    value={category.expense_category_id}
                                  >
                                    {category.expense_category}
                                  </option>
                                ))}
                              </Form.Control>
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                value={row.amount}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "amount",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                value={row.remarks}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "remarks",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Button
                                variant="danger"
                                onClick={() => handleRemoveRow(index)}
                                disabled={rows.length === 1}
                              >
                                Remove
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-end">
                      <Button
                        className="mb-3"
                        variant="primary"
                        onClick={handleAddRow}
                      >
                        Add New Row
                      </Button>
                    </div>
                  </div> */}
                  <div className="mt-2">
                    <h5 style={{ color: "black" }}>Expense Detail</h5>

                    {/* Responsive wrapper */}
                    <div className="table-responsive">
                      <Table bordered hover>
                        <thead className="thead-dark">
                          <tr>
                            <th>Sr.No</th>
                            <th>Expense Category</th>
                            <th>Amount</th>
                            <th>Remarks</th>
                            <th>Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((row, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <Form.Control
                                  as="select"
                                  className="form-select"
                                  value={row.category}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "category",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  {expenseCategory.map((category) => (
                                    <option
                                      key={category.expense_category_id}
                                      value={category.expense_category_id}
                                    >
                                      {category.expense_category}
                                    </option>
                                  ))}
                                </Form.Control>
                              </td>
                              <td>
                                <Form.Control
                                  type="text"
                                  value={row.amount}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "amount",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="text"
                                  value={row.remarks}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "remarks",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Button
                                  variant="danger"
                                  onClick={() => handleRemoveRow(index)}
                                  disabled={rows.length === 1}
                                >
                                  Remove
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="d-flex justify-content-end">
                      <Button
                        className="mb-3"
                        variant="primary"
                        onClick={handleAddRow}
                      >
                        Add New Row
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row p-2">
                <div
                  className="col-12 p-2 mt-3"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    background: "white",
                  }}
                >
                  {/* Cash Input Field */}
                  <Row className="align-items-center mb-2 g-2">
                    <Col xs={3} sm={2} md={1}>
                      <strong>CASH</strong>
                    </Col>
                    <Col xs={9} sm={4} md={3}>
                      <Form.Control
                        type="text"
                        value={cashAmount}
                        onChange={handleCashChange}
                      />
                    </Col>
                  </Row>

                  <Row className="align-items-center mt-3 g-2">
                    <Col xs={3} sm={2} md={1}>
                      <strong>BANK</strong>
                    </Col>
                    <Col xs={9} sm={3} md={2}>
                      <Form.Select
                        onChange={handleBankChange}
                        value={selectedBank}
                      >
                        <option value="">Select Bank</option>
                        {loadingBanks ? (
                          <option>Loading...</option>
                        ) : errorBanks ? (
                          <option>{errorBanks}</option>
                        ) : (
                          bankList.map((bank) => (
                            <option key={bank.id} value={bank.id}>
                              {bank.bankname}
                            </option>
                          ))
                        )}
                      </Form.Select>
                    </Col>

                    <Col xs={12} sm={3} md={3}>
                      <Form.Select
                        disabled={!selectedBank || loadingAccounts}
                        onChange={handleAccountChange}
                        value={selectedAccount}
                      >
                        <option value="">
                          {loadingAccounts
                            ? "Loading..."
                            : errorAccounts
                            ? errorAccounts
                            : "Select Branch"}
                        </option>
                        {!loadingAccounts &&
                          !errorAccounts &&
                          accountList.map((account) => (
                            <option key={account.id} value={account.id}>
                              {account.bank_account} - {account.ifsc}
                            </option>
                          ))}
                      </Form.Select>
                    </Col>

                    <Col xs={12} sm={4} md={3}>
                      <Form.Control
                        disabled={!selectedBank && !bankAmount}
                        type="text"
                        value={bankAmount}
                        onChange={handleBankAmountChange}
                        placeholder="Enter bank amount"
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
